import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ApiLog } from 'dashboard/models/api-log';
import { Environment } from 'dashboard/models/environment';
import { ApiLogsFilterParams, setApiLogs } from 'dashboard/redux/slices/api-logs';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadApiLogList({
  currentEnvironment,
  currentPage,
  pageSize,
  filters,
}: {
  currentEnvironment: Environment;
  currentPage: number;
  pageSize: number;
  filters: ApiLogsFilterParams;
}) {
  return async (dispatch: Dispatch) => {
    const paramsFull = {
      ...createParamsForList(currentEnvironment, filters),
      page: {
        number: currentPage,
        size: pageSize,
      },
    };

    const { data: apiLogs, meta: paginationParams } = await SessionClientDashboard.listResource<
      ApiLog,
      PaginationParams
    >(ApiEndpoint.ApiLog, paramsFull);

    dispatch(
      setApiLogs({
        apiLogs,
        environment: currentEnvironment,
        paginationParams,
      }),
    );
  };
}

function createParamsForList(currentEnvironment: Environment, filters: ApiLogsFilterParams) {
  const { createdAtStart, createdAtEnd, omni, status, methods, apiKeyIds } = filters;

  return {
    filter: {
      'environment-id': currentEnvironment.id,
      omni,
      'created-at-start': createdAtStart && createdAtStart.toString(),
      'created-at-end': createdAtEnd && createdAtEnd.toString(),
      status,
      methods,
      'api-key-ids': apiKeyIds,
    },
  };
}
